import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { ClipLoader } from "react-spinners";

const SubmitPoll = (props) => {
  const { id } = useParams();
  const urlParams = new URLSearchParams(id.split("?")[0]);
  const pollSlug = urlParams.get("poll_slug");
  const pollOptionId = urlParams.get("poll_option_id");


  const [submitting, setSubmitting] = useState(false);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    props.submitResponse(id, setSubmitting);
  }, [id]);

  useEffect(() => {
    if (loader && !submitting) {
      const timeout = setTimeout(() => {
        navigate("/thank-you?slug=" + pollSlug + "&submitted_option=" + pollOptionId);
      }, 1500);

      return () => clearTimeout(timeout);
    }
  }, [loader, submitting, navigate]);

  return (
    <div>
      {loader && (
        <div style={styles.loaderContainer}>
          <ClipLoader color={"#123abc"} loading={loader} size={50} />
          <p style={styles.loadingText}>
            Please wait while we submit your response...
          </p>
        </div>
      )}
    </div>
  );
};

const styles = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    textAlign: "center",
    backgroundColor: "#f6f6f6",
  },
  loadingText: {
    marginTop: "20px",
    fontSize: "16px",
  },
};

export default SubmitPoll;
